import CircleIcon from "@mui/icons-material/Circle";
import * as PropTypes from "prop-types";

Tile.propsTypes = {
    size: PropTypes.number,
    color: PropTypes.object,
    opacity: PropTypes.number,
    onTileClick: PropTypes.func,
    colors: PropTypes.array,
    editable: PropTypes.bool,
}

export function Tile(props) {
    let colorValue = props.colors.find(c => c.id === props.color).color;
    return (
        <div
            className="tile"
            style={{
                width: props.size + 'px',
                height: props.size,
                borderColor: "rgba(0, 0, 0," + props.opacity + ")",
                cursor: props.editable ? 'crosshair' : 'default'
            }}
            onClick={props.onTileClick}
            onContextMenu={props.onTileClick}
        >
            {props.color > 0 &&
                <CircleIcon style={{position: "relative", color: colorValue, fontSize: props.size + 1}}/>}
        </div>
    );
}